import React, { useState, useCallback, useEffect } from 'react';

import { FormPessoa } from '../../../components/FormPessoas';
import { ErrorRetrievingData } from '../../../components/ErrorRetrievingData';
import MenuMain from '../../../MenuMain';
import { AppFooter } from '../../../AppFooter';
import api from '../../../api/api';
import EscolaEnsinoProvider from '../../../contexts/EscolaEnsinoContext';

// import { ensinoService } from '../../services/ensinoService';

export default function CadastrarPessoaPage() {

  const defaultValues = {
    "id": '',
    "nome": '',
    "cpfcnpj": '',
    "celular": '',
    "tipoId": "",
    "tipoDescricao": ""
  }

  const [pessoas, setPessoas] = useState([]);
  const [pessoasTipo, setPessoasTipo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorRetrievingData, setErrorRetrievingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        // const ensinos = await ensinoService.listAll();
        const response = await api.get("pessoa");
        defaultValues.pessoas = response.data;
        setPessoas(response.data);
        setErrorRetrievingData(false);
        setIsLoading(false);
      }
      catch (error) {
        setErrorMessage(error.toString());
        setErrorRetrievingData(true);
        setIsLoading(false);
      }
    }
    getData();
  }, [])

  return (
    <>
      <MenuMain>
        {
          errorRetrievingData ?
            <ErrorRetrievingData
              errorMessage={errorMessage}
              // retrieveFunction={() => getData()}
              isLoading={isLoading}
            />
            :
            <FormPessoa
              defaultValues={defaultValues}
              isLoading={isLoading}
              isEditing={false}
            // ensinos={pessoas}
            // ensinosCadastrados={ensinosCadastrados}
            // setEnsinosCadastrados={setEnsinosCadastrados}
            />
        }
      </MenuMain>
      <AppFooter />
    </>
  );
}